const NFIRS_UPLOAD_TYPES = {
  FTP: 'ftp',
  SFTP: 'sftp',
  MC_SFTP: 'mcsftp',
  NFIRS_SITE: 'site',
};

export default NFIRS_UPLOAD_TYPES;
